import React from "react";
import { Routes, Route, Outlet, Navigate, useLocation } from "react-router-dom";

// Core Route Wrappers
import { PrivateRoute } from "../private-route";

// Authentication - Signup Flow
import Signup from "../features/auth/pages/signup_flow/Signup";
import EmailVerification from "../features/auth/pages/signup_flow/EmailVerification";
import FirebaseMobile from "../features/auth/pages/signup_flow/FirebaseMobile";

// Authentication - Login Flow
import Login from "../features/auth/pages/login_flow/Login";
import ForgotPassword from "../features/auth/pages/login_flow/ForgotPassword";
import ResetPasswordConfirmation from "../features/auth/pages/login_flow/ResetPasswordConfirmation";
import ResetPassword from "../features/auth/pages/login_flow/ResetPassword";

// Main App Layout
import MainLayout from "./MainContainer";
import DashboardV2 from "../features/dashboard-v2/DashboardV2"
import LedgerPage from "../features/ledger"
import HistoryPage from "../features/history/HistoryPage";
import DocumentsPage from "../features/documents/DocumentsPage";
import SettingsPage from '../features/settings/SettingsPage'
import Capital from '../features/capital/Capital'
import SignalPage from '../features/signals/SignalPage'
import Perks from '../features/perks/Perks'
import MarginV2 from '../features/margin/MarginV2'
import AllBusinessesPage from "../features/admin/AllBusinessesPage";
import AdminDebugConsole from "../features/admin/AdminDebugConsole";
import AdminGLCodePage from "../features/admin/AdminGLCodePage";
import AdminOpsPage from "../features/admin/AdminOpsPage";
import AdminConfigPage from "../features/admin/AdminConfigPage";
import AdminAuditTrailPage from "../features/admin/AdminAuditTrailPage";
import AdminBillingPage from "../features/admin/AdminBillingPage";
import AdminLayout from "../features/admin/AdminLayout";
import AdminBusinessDetailPage from "../features/admin/AdminBusinessDetailPage";
import AdminSupportPage from "../features/admin/AdminSupportPage";
import { AdminContextProvider } from "../features/admin/AdminContext";
import { UserProvider } from "../context/UserContext";

const AdminShell = () => (
  <MainLayout>
    <AdminContextProvider>
      <AdminLayout>
        <Outlet />
      </AdminLayout>
    </AdminContextProvider>
  </MainLayout>
);

const LegacyRedirect = ({ to }: { to: string }) => {
  const location = useLocation();
  return <Navigate to={`${to}${location.search}${location.hash}`} replace />;
};


function Main() {
  return (
    <UserProvider>
      <Routes>

        {/* Signup Flow */}
        <Route path="/signup" element={<Signup />} />
        <Route path="/firebase-mobile" element={<FirebaseMobile />} />
        <Route path="/emailverification" element={<EmailVerification />} />

        {/* Login Flow */}
        <Route path="/" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password-confirmation" element={<ResetPasswordConfirmation />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        {/* Main App - PrivateRoute */}
        <Route element={<PrivateRoute />}>

          {/* Margin */}
          {/* <Route path="/margin" element={<MainLayout><Margin /></MainLayout>} /> */}
          <Route path="/margin" element={<MainLayout><MarginV2 /></MainLayout>} />

          {/* Perks */}
          <Route path="/perks" element={<MainLayout><Perks /></MainLayout>} />

          {/* Capital */}
          <Route path="/capital" element={<MainLayout><Capital /></MainLayout>} />

          {/* Cash */}
          <Route path="/cash" element={<MainLayout><DashboardV2 /></MainLayout>} />
          <Route path="/dashboard" element={<LegacyRedirect to="/cash" />} />

          {/* Signals */}
          <Route path="/home" element={<MainLayout><SignalPage /></MainLayout>} />

          {/* AI CFO Chat / Admin Home */}
          {/* <Route path="/home" element={<MainLayout><HomeView /></MainLayout>} /> */}

          {/* Admin Routes */}
          <Route path="/admin" element={<AdminShell />}>
            <Route index element={<AllBusinessesPage />} />
            <Route path="business/:businessId" element={<AdminBusinessDetailPage />} />
            <Route path="business/:businessId/:section" element={<AdminBusinessDetailPage />} />
            <Route path="ops" element={<AdminOpsPage />} />
            <Route path="gl-code" element={<AdminGLCodePage />} />
            <Route path="logs" element={<AdminDebugConsole />} />
            <Route path="audit" element={<AdminAuditTrailPage />} />
            <Route path="debug" element={<AdminDebugConsole />} />
            <Route path="config" element={<AdminConfigPage />} />
            <Route path="billing" element={<AdminBillingPage />} />
            <Route path="support" element={<AdminSupportPage />} />
          </Route>

          {/* Ledger */}
          <Route path="/ledger" element={<MainLayout><LedgerPage /></MainLayout>} />

          {/* History */}
          <Route path="/history" element={<MainLayout><HistoryPage /></MainLayout>} />

          {/* Drive */}
          <Route path="/drive" element={<MainLayout><DocumentsPage /></MainLayout>} />
          <Route path="/documents" element={<LegacyRedirect to="/drive" />} />

          {/* Settings */}
          <Route path="/settings" element={<MainLayout><SettingsPage /></MainLayout>} />

        </Route>

      </Routes>
    </UserProvider>
  );
}

export default Main
